import { get } from '@namespace/helpers';
import apiRoutes from './apiRoutes';

export const getWebimInfo = () => get(apiRoutes.getWebimInfo);
